<div [id]="mapId" [style.width]="width" [style.height]="height" [style.minHeight]="height" [style.maxHeight]="height"></div>
